import type { WidgetAutocheck } from "@redotech/redo-storefront-widget-common/widget";
import { RedoEmittedDomEvent } from "../dom-events";

export const COVERAGE_BUILDER_AUTOCHECK_TIMEOUT_MS = 15_000;

/** Undefined if the host never pushes one, so a failed handshake can't wedge coverage init. */
export function waitForCoverageBuilderAutocheck(
  timeoutMs = COVERAGE_BUILDER_AUTOCHECK_TIMEOUT_MS,
): Promise<WidgetAutocheck | undefined> {
  const currentAutocheck = globalThis.redoStorefront?.newAutocheck;
  if (currentAutocheck) {
    return Promise.resolve(currentAutocheck);
  }
  return new Promise((resolve) => {
    const settle = (autocheck: WidgetAutocheck | undefined) => {
      clearTimeout(timeout);
      document.removeEventListener(
        RedoEmittedDomEvent.RefreshAutocheck,
        onRefresh,
      );
      resolve(autocheck);
    };
    // A refresh without an autocheck must not consume our only chance to hear the next.
    const onRefresh = () => {
      const autocheck = globalThis.redoStorefront?.newAutocheck;
      if (autocheck) {
        settle(autocheck);
      }
    };
    const timeout = setTimeout(() => settle(undefined), timeoutMs);
    document.addEventListener(RedoEmittedDomEvent.RefreshAutocheck, onRefresh);
  });
}
